import React, { useState, useEffect, useContext, useRef } from 'react';
import { ReactSortable } from "react-sortablejs";

import CopyToClipboard from 'react-copy-to-clipboard-ts';
import { DcContext } from './context';
import Util from '../util';
import useIsVisible from './useIsVisible'; 


const LegalText = (props) => {

	// * state
	const [legalCopyData, setLegalCopyData] = useState([]);
	const [legalSort, setLegalSort] = useState([]);
	const [symbolsUsed, setSymbolsUsed] = useState([]);
	const [copied, setCopied] = useState(false); 
	const [orderUpdated, setOrderUpdated] = useState(true); 
	//const [dcData, setDcData] = useState({}); 
	const [formState, setFormState] = useState({}); 

	// * context 
	const appContext = useContext(DcContext);

	// * helpers 
	const getSymbol = (sym) => {
		// todo: check for dupes?
		let symsUsed = symbolsUsed;
		symsUsed.push(sym);
		setSymbolsUsed(symsUsed);
		return sym;
	}	

	// * legal text logic 
	const getLegalCopyData = () => {
		const config = props.config;
		const dcData = appContext.getDcData(); 
		let out = [];
		const fy = (new Date()).getFullYear();

		if (!dcData || Object.keys(dcData).length == 0) {
			return [];
		}
		if (!formState || Object.keys(formState).length == 0) {
			return [];
		}

		const placeholders = (val) => {
			// todo: placeholder mechanism 
			let out = val.replaceAll('[YEAR]', fy);
			out = out.replaceAll('[TM]', '™️');
			return out; 
		};

		// replace plain copy with jsx stack
		const preformatCopy = (val) => {
			// handle just trademark char currently 
			const tradeIdx = val.indexOf('™️'); 
			if (tradeIdx >=0) {
				//console.log('trademark', val); 
				const pre = [];
				const segs = val.split('™️');
				for (var i=0; i <= segs.length-2; i++) {
					pre.push((<span key={i}>{segs[i]}</span>));
					pre.push((<sup key={'tm'+ i}>&trade;</sup>)); 
				}
				pre.push((<span key={segs.length - 1}>{segs[segs.length - 1]}</span>)); 
				const out = (<>{pre}</>);
				//console.log(out);
				return out; 
			}
			//return (<>{val}</>); 
			return (val); 
		};

		// get object containing copy and metadata 
		const getCopyData = (di) => {
			//console.log('di', di); 
			const copy = placeholders(di[config.LegalColumn]);
			let copyData = {};
			copyData.rowNum = di.rowNum;  
			if (copy && copy != "{BLANK}") {
				// plain text copy metadata 
				if (di.bold) {
					copyData.bold = true;
				}
				if (di.symbol) {
					let symbol = getSymbol(di.symbol);
					copyData.copy = symbol + copy;
					copyData.symbol = symbol;
				} else {
					copyData.copy = copy;
				}

				// formatted copy metadata (jsx)
				copyData.formatted = [];
				if (!config.DisplayRTF || !di.formatData) {
					// no formatting .. except trademark
					const preformatted = preformatCopy(copyData.copy); 
					if (di.bold) {
						copyData.formatted = [<b key='0' className='bold'>{preformatted}</b>];
					} else {
						copyData.formatted = [<span key='0'>{preformatted}</span>];
					}
				} else {
					// parse sheet formatting!
					copyData.formatted = parseFormatting(di.formatData);
				}

			} else if (copy ==="{BLANK}") {
				copyData.copy = " ";
				copyData.formatted = [<span key='0'> </span>];

			} else {
				copyData.error = "!no copy"
			}
			return copyData;
		};

		// parse formating from sheet 
		const parseFormatting = (formatData) => {
			//console.log('formatData', formatData);
			const out = [];
			const text = formatData.text;
			formatData.textFormatRuns.forEach((fmtRun, i) => {
				const fmt = fmtRun.format;
				// get text run
				const startIndex = fmtRun.startIndex || 0;
				const nextIndex = formatData.textFormatRuns[i + 1] ? (formatData.textFormatRuns[i + 1].startIndex) : undefined;
				const textRun = text.substring(startIndex, nextIndex);
				// placeholders and special formatting 
				const preformatRun = preformatCopy(placeholders(textRun)); 

				// supported formating: bold and colored text
				const cssClass = [];
				let cssStyle = {};
				if (fmt.bold) cssClass.push('bold');
				if (fmt.foregroundColor) {
					const rgb = Util.percentText(fmt.foregroundColor.red) + " " +
						Util.percentText(fmt.foregroundColor.green) + " " +
						Util.percentText(fmt.foregroundColor.blue);
					cssStyle = { color: `rgb(${rgb})` };
				}
				out.push(
					<span key={i} className={cssClass.join(' ')} style={cssStyle}>
						{preformatRun}
					</span>
				);
			});
			//console.log('parsed', out)
			return out;
		}

		// prelude legal copy 
		const dcAll = dcData.getSection('All') || [];
		dcAll.forEach((di) => {
			if (di.type == 'Begin') {
				if (di[formState.getRegion()] || !formState.hasRegions()) {
					out.push(getCopyData(di));
				}
			}
		});

		if (!config.Sections) {
			return out;
		}

		// legal copy for each section 
		config.Sections.forEach((sec) => {
			if (formState.sectionItems[sec.key]) {
				if (dcData.getSection(sec.key)) {
					// product section labels TODO? 
					if (sec.label
						&& formState.sectionItems[sec.key]
						&& formState.sectionItems[sec.key].length > 0) {
						//out.push(sec.label);
					}

					// selected options for section 
					dcData.getSection(sec.key).forEach((di) => {
						if (di.type.toLowerCase() != 'setting') {
							if (formState.sectionItems[sec.key].indexOf(di.key) >= 0) {
								out.push(getCopyData(di));
							}
						}
					});
				}
			}
		});

		// ending legal copy 
		dcAll.forEach((di) => {
			if (di.type.toLowerCase() == 'end') {
				if (di[formState.getRegion()] || !formState.hasRegions()) {
					out.push(getCopyData(di));
				}
			}
		});

		return out;
	}	


	// * component mount/update
	useEffect(
		() => {
			setFormState(props.formState); 
			// LegalCopyData - array of selected legal disclaimers, formatted and raw
			const lcd = getLegalCopyData(); 
			setLegalCopyData(lcd); 
			// LegalSort used by Sortable component 
			// array of objects [{id: rowNum}, ]
			const ls = lcd.map((item) => {
				return ({ id: item.rowNum }); 
			});
			setLegalSort(ls); 
			setOrderUpdated(true); 
		},
		[props]
	); 	

	// * events
	// update textarea
	const copyChange = (evt) => {
		// this.setState({legalCopy : evt.target.value});
	};


	// ** render 
	//console.log('legalCopyData', legalCopyData); 
	let legalParts = [];
	let legalListItems = [];
	let legalTexts = [];
 
	legalCopyData.forEach((cd, i) => {
		//console.log('render', cd);
		let lp = null; 
		let lpText = null; 
		const lpKey = cd.rowNum.toString(); 
		if (cd.copy && cd.formatted) {
			// raw copy 
			lpText = cd.copy + " "; 
			// formatted copy
			cd.formatted.push(
				// add space 
				<span key={cd.formatted.length}> </span>
			);
			lp = (
				<span key={i}>{cd.formatted}</span>
			); 
		} else if (cd.copy) {
			// raw copy 
			// plain copy, add formatting (old path)
			let copy = cd.copy + " ";
			lpText = copy; 
			if (cd.bold) {
				lp = (
					<b key={i}>{copy}</b>
				);
			} else {
				lp = (
					<span key={i}>{copy}</span>
				);
			}
		}

		if (lp) {
			legalParts[lpKey] = lp;  
			legalListItems[lpKey] = <li key={lpKey}>{lp}</li>; 
			legalTexts[lpKey] = lpText; 
		}
	}); 

	const legalText = legalSort.map((ls) => (
		legalTexts[ls.id]
	)).join(''); 

	//console.log('legalListItems', legalListItems);
	//console.log('legalParts', legalParts);
	//console.log('legalSort', legalSort);
	//console.log('legalText', legalText);

	const allowReordering = props.config.AllowReordering; 
	const stickyText = props.config.StickyLegalText; 

	// determine if visible using helper 
	const ref = useRef(); 
	const isVisible = useIsVisible(ref); 

	return (
		<div ref={ref} className={"legal-wrapper " + (legalText.length > 0 ? "has-legal" : "")}>
			<h2>Disclaimer</h2>
			<p className={'legal-note' + (allowReordering ? '':' display-none')}>drag-&-drop: enabled</p>
			<ul className={'legal-text' + (orderUpdated ? " updated" : "") + (allowReordering ? " sortable": "")}>
				<ReactSortable list={legalSort} setList={setLegalSort} 
					disabled={!allowReordering}
					animation={200}
					delayOnTouchStart={true}
					delay={2}>
						{legalSort.map((ls) => (
							legalListItems[ls.id]
						))}
				</ReactSortable>
			</ul>
			<div className={'legal-overlay' + (stickyText && !isVisible ? ' pinned': '')}>
				<div className='legal-textblock'>
					{legalSort.map((ls) => (
						legalParts[ls.id]
					))}
				</div>
			</div>
			<CopyToClipboard text={legalText}
				onCopy={() => setCopied(true)}>
				<button className='btn btn-info btn-disclaimer btn-copy'>
					<span className='glyphicon glyphicon-copy'></span>&nbsp;Copy
				</button>
			</CopyToClipboard>
		</div>
	);


};



export default LegalText;
